import { render, staticRenderFns } from "./MergeRadishes.vue?vue&type=template&id=f9acb520&"
import script from "./MergeRadishes.vue?vue&type=script&lang=js&"
export * from "./MergeRadishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports